import React from "react";
import "./style.css";

const FAQs = () => {
  return (
    <div className="row px-4 qna">
      <div className="col-12 col-lg-6 p-0">
        <div className="FAQs-inr">
          <div class="accordion accordion-flush" id="accordionFlushExample">
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingOne">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="false"
                  aria-controls="collapseOne"
                >
                  What is KidEx?
                </button>
              </h2>
              <div
                id="collapseOne"
                class="accordion-collapse collapse"
                aria-labelledby="headingOne"
                data-bs-parent="#accordionFlushExample"
              >
                <div class="accordion-body">
                  <p>
                    KidEx is a platform for parents & schools to improve child’s
                    holistic development profile for better career potential.
                    The company provides all extracurriculars, co-curriculars &
                    life skills programs in the form of live classes,
                    self-learning certification courses & digital competitions
                    for children of age group 5 to 17 years. KidEx’s unique
                    scientific framework created by experts from MIT, IIT, IIM &
                    NITI Aayog comprises of 96 sub-themes related to child’s
                    holistic development ensures every program is
                    age-appropriate & comes with a detailed course curriculum to
                    guarantee learning outcomes.
                  </p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingTwo">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  How does KidEx help with child development?
                </button>
              </h2>
              <div
                id="collapseTwo"
                class="accordion-collapse collapse"
                aria-labelledby="headingTwo"
                data-bs-parent="#accordionFlushExample"
              >
                <div class="accordion-body">
                  <p>
                    Most learning programs are either rote learning based or
                    limited to knowledge dissemination. “Learning by doing” or
                    “Experiential learning” is the most effective way of
                    enabling learning. KidEx programs are designed to enable
                    “Learning by Doing” which helps child develop truly.
                    Children indulge in programs related to cognitive skills,
                    creativity & imagination skills, socio-emotional skills,
                    physical skills and language & communication skills and
                    attempt different projects, assignments & activities in a
                    “Learn by Do” format to achieve a gradual improvement in
                    their development profile.
                  </p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingThree">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  Are your programs and activities for extracurricular
                  activities age appropriate?
                </button>
              </h2>
              <div
                id="collapseThree"
                class="accordion-collapse collapse"
                aria-labelledby="headingThree"
                data-bs-parent="#accordionFlushExample"
              >
                <div class="accordion-body">
                  <p>
                    KidEx has created a unique scientific framework by experts
                    from MIT, IIT, IIM & NITI Aayog comprising of 96 sub-themes
                    related to child’s holistic development. The framework
                    codifies development milestones for every age group from 3
                    years up to 17 years across the 96 sub-themes. Each & every
                    program and activities designed & offered by KidEx is basis
                    this framework making it age-appropriate.
                  </p>
                </div>
              </div>
            </div>
            {/* 4 */}
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingFour">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFour"
                  aria-expanded="false"
                  aria-controls="collapseFour"
                >
                  Does KidEx have scientific holistic development framework?
                </button>
              </h2>
              <div
                id="collapseFour"
                class="accordion-collapse collapse"
                aria-labelledby="headingFour"
                data-bs-parent="#accordionFlushExample"
              >
                <div class="accordion-body">
                  <p>
                    KidEx has created a unique scientific framework by experts
                    from MIT, IIT, IIM & NITI Aayog comprising of 96 sub-themes
                    related to child’s holistic development. The entire
                    framework is designed a 3-tier system. 5 key themes exist at
                    the top tier: Cognitive skills, Socio-emotional skills,
                    Creativity & Imagination skills, Physical skills and
                    Language & Communication skills. Further sub-classification
                    is done under each of the 5 themes. The framework codifies
                    development milestones for every age group from 3 years up
                    to 17 years across the 96 sub-themes. The designed framework
                    is in sync with globally available research findings related
                    to child development across geographies (India, Japan,
                    Europe, America, Australia etc.)
                  </p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingFive">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFive"
                  aria-expanded="false"
                  aria-controls="collapseFive"
                >
                  Do extracurricular activities impact life skills? If yes, why
                  are they important?
                </button>
              </h2>
              <div
                id="collapseFive"
                class="accordion-collapse collapse"
                aria-labelledby="headingFive"
                data-bs-parent="#accordionFlushExample"
              >
                <div class="accordion-body">
                  <p>
                    Key skills that employers look for in individuals are Team
                    work, Leadership skills, Critical thinking, Problem solving,
                    Time management, Stress management, Active listening,
                    Empathy etc. These skills are not taught in classroom
                    programs in school but are taught through Experiential
                    Learning programs. All across the world, Experiential
                    Learning programs related to Extracurriculars is the trusted
                    way to teach these skills to any individuals.
                  </p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingSix">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseSix"
                  aria-expanded="false"
                  aria-controls="collapseSix"
                >
                  I am a busy parent. Can KidEx suggest what should my child
                  pursue?
                </button>
              </h2>
              <div
                id="collapseSix"
                class="accordion-collapse collapse"
                aria-labelledby="headingSix"
                data-bs-parent="#accordionFlushExample"
              >
                <div class="accordion-body">
                  <p>
                    Yes, of course. We recommend deciding one of the 5 themes on
                    which you want to get the child’s learning journey started.
                    The child can sign up for any of the Experiential Programs
                    related to that skill or attend a few FREE classes in
                    activities related to that theme. Once started, during class
                    interactions, the child will continue to Explore &
                    Experience new activities & learning topics to improve
                    his/her development profile. If you want recommendation from
                    us to get the child started, you can always write to us at
                    info@kid-ex.com & our concerned team member will advise you.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-6 p-0">
        <div className="FAQs-inr">
          <div class="accordion accordion-flush" id="accordion2">
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingSeven">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseSeven"
                  aria-expanded="false"
                  aria-controls="collapseSeven"
                >
                  Why should I sign up with KidEx?
                </button>
              </h2>
              <div
                id="collapseSeven"
                class="accordion-collapse collapse"
                aria-labelledby="headingSeven"
                data-bs-parent="#accordion2"
              >
                <div class="accordion-body">
                  <p>
                    You should sign up with KidEx to offer best learning
                    programs for 21st century skills to your child/students
                    which are highest quality, experts curated, industry
                    recognized & high value-for-money. KidEx solutions are
                    phygital ensuring low screen time & makes screen time very
                    productive for children. Parents have reported to be able to
                    identify new natural talents in their child through KidEx
                    programs which they were otherwise not aware of.
                  </p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingEight">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseEight"
                  aria-expanded="false"
                  aria-controls="collapseEight"
                >
                  Is the mission of KidEx aligned with NEP 2020?
                </button>
              </h2>
              <div
                id="collapseEight"
                class="accordion-collapse collapse"
                aria-labelledby="headingEight"
                data-bs-parent="#accordion2"
              >
                <div class="accordion-body">
                  <p>
                    KidEx’s mission is to make India the World’s Largest
                    Economy. For the same, to happen India needs to achieve 10X
                    growth in GDP per capita. For this, 10X number of Indians
                    should have employability skills to take up global jobs from
                    India. And while achieving these goals, remain rooted to
                    strong cultural values & heritage of the company. This is
                    also the aim of the National Education Policy 2020 (NEP
                    2020) & the entire Section 4 of the NEP 2020 is dedicated to
                    the above. KidEx’s solutions are 100% in sync with NEP 2020
                    & helps every school implement Section 4 of NEP 2020 in the
                    most convenient manner, at zero overhead for school teachers
                    in the most affordable manner.
                  </p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingNine">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseNine"
                  aria-expanded="false"
                  aria-controls="collapseNine"
                >
                  Do extracurriculars have positive impact on child's academic
                  performance?
                </button>
              </h2>
              <div
                id="collapseNine"
                class="accordion-collapse collapse"
                aria-labelledby="headingNine"
                data-bs-parent="#accordion2"
              >
                <div class="accordion-body">
                  <p>
                    Extracurriculars have been found to have a very high
                    positive correlation with academic performance.
                    Extracurriculars help a child develop multiple skills which
                    enable a superior academic performance e.g., being focused,
                    critical thinking, attention to detail, unlearn & re-learn,
                    time management, stress management etc. Activities like
                    Chess, Rubik’s Cube improve performance in Maths & Sciences.
                    Activities like Foreign languages, Sign languages improves
                    vocabulary, grammar. Balanced approach is important like in
                    everything else – if someone does only extracurriculars and
                    not academics, it will obviously impact academic performance
                    adversely.
                  </p>
                </div>
              </div>
            </div>
            {/* 4 */}
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingTen">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTen"
                  aria-expanded="false"
                  aria-controls="collapseTen"
                >
                  Are age-appropriate milestones tracked for children as part of
                  holistic development framework?
                </button>
              </h2>
              <div
                id="collapseTen"
                class="accordion-collapse collapse"
                aria-labelledby="headingTen"
                data-bs-parent="#accordion2"
              >
                <div class="accordion-body">
                  <p>
                    KidEx has a 360-degree system for tracking age-appropriate
                    development milestones. The software enables
                    self-assessment, peer-to-peer assessment & specialist
                    teacher assessment. The assessments are compiled as a
                    Holistic Development Report Card for every child.
                  </p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingEleven">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseEleven"
                  aria-expanded="false"
                  aria-controls="collapseEleven"
                >
                  How can I choose best extracurricular activities and programs
                  for my child?
                </button>
              </h2>
              <div
                id="collapseEleven"
                class="accordion-collapse collapse"
                aria-labelledby="headingEleven"
                data-bs-parent="#accordion2"
              >
                <div class="accordion-body">
                  <p>
                    At KidEx, our philosophy is Explore-Experience-Excel. Let
                    the child Explore multiple activities & programs. National
                    All Rounder Championship or Champions offered by KidEx is a
                    great way to achieve this goal. Once the child has Explored
                    different activities, the child would like a few of them to
                    indulge in them more regularly & seriously. Let the child
                    Experience a few activities. KidEx Live Classes is a great
                    way to achieve this goal. Basis this, the child will
                    demonstrate Excellence in one or two activities. Let the
                    child Excel in them. This is a continuous process of
                    learning & keeps repeating in every age group for the child.
                  </p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingTwelve">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwelve"
                  aria-expanded="false"
                  aria-controls="collapseTwelve"
                >
                  Is KidEx a popular / awarded / trusted brand?
                </button>
              </h2>
              <div
                id="collapseTwelve"
                class="accordion-collapse collapse"
                aria-labelledby="headingTwelve"
                data-bs-parent="#accordion2"
              >
                <div class="accordion-body">
                  <p>
                    KidEx is trusted by 1 Mn+ families & 10k+ schools in India
                    already. KidEx has been recognized by Google & Ministry of
                    Electronics & Information Technology (MeitY) as the most
                    innovative EdTech company in India in 2022 with globally
                    disruptive product. KidEx has been recognized earlier by
                    popular neutral parties like Yourstory & NASSCOM as the Top
                    tech start-ups in India in 2021. KidEx has been selected by
                    NITI Aayog to partner with them in promoting Innovation &
                    Entrepreneurship amongst school students all over India.
                    Reputed National Heroes like Dr. R Chidambaram, Mr. R
                    Ramanan & Major Gen. Vikram Dev Dogra have graced multiple
                    KidEx events as Chief Guest to motivate & inspire children
                    to work on their holistic development.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQs;
